import React, { useCallback } from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';

import exportXlsx from './export';

const ExportCSV = React.memo(
  ({ csvData, itemName, type, dateValue, dateFilterFormat, headerCell }) => {
    const [t] = useTranslation();

    const handleExport = useCallback(() => {
      const headers = [t('common.name'), ...headerCell];
      const date = format(dateValue, dateFilterFormat);

      exportXlsx(csvData, headers, type, {
        name: `Báo cáo ${t(`common.reportType.${type}`)} (${itemName}) - ${date}`,
      });
    }, [csvData, dateFilterFormat, dateValue, headerCell, itemName, t, type]);

    return <Button onClick={handleExport}>{t('action.exportReport')}</Button>;
  },
);

ExportCSV.propTypes = {
  csvData: PropTypes.arrayOf(PropTypes.any).isRequired,
  itemName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  dateValue: PropTypes.instanceOf(Date),
  dateFilterFormat: PropTypes.string,
  headerCell: PropTypes.arrayOf(PropTypes.any).isRequired,
};

ExportCSV.defaultProps = {
  dateValue: undefined,
  dateFilterFormat: undefined,
};

export default ExportCSV;
